import React from "react";
import { Toast } from "react-weui";

import * as Api from "../api/oauth";
import Const from "../utils/const";
import Auth from "../utils/auth";
import Config from "../utils/config";
import { UrlSearch } from "../utils/utils";
import Error from "../component/Error/Error";

export default class Login extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			error: false,
			errorMsg: ""
		};
	}

	componentDidMount() {
		// 从 URL 中有无 code 判断有没有经过微信认证，若无则跳转至微信进行认证拿到 code。
		if (!Auth.isWeChatAuthOk()) {
			if (!Config.OauthUrlPrefix) {
				this.setState({
					error: true,
					errorMsg: Const.CONFIG_ERROR
				});
			} else {
				window.location.href = `${Config.OauthUrlPrefix}&redirect_uri=${encodeURI(
					window.location.toString()
				)}&response_type=code&scope=snsapi_base&state=${Date.now()}#wechat_redirect`;
			}
		} else {
			// 微信认证后使用 code 去登陆，登陆成功拿到 ServiceTicket 存至 cookie。
			Api.userLogin(Auth.getWechatCode())
				.then(res => {
					Auth.setLocalAuthInfo(res.Data);
					if (UrlSearch("referer")) {
						window.location.href = decodeURI(UrlSearch("referer"));
					} else {
						window.location.href = "/";
					}
				})
				.catch(err => {
					console.log(err);
					this.setState({
						error: true,
						errorMsg: Const.WECHATAUTH_ERROR
					});
				});
		}
	}

	render() {
		return this.state.error ? <Error msg={this.state.errorMsg} /> : <Toast icon="loading" show={true} />;
	}
}
